export const createHeading = (text: string) => {
  return {
    rootId: "251f8838-17ab-4533-a351-24bc74f6c970",
    layers: {
      "251f8838-17ab-4533-a351-24bc74f6c970": {
        type: { resolvedName: "TextLayer" },
        props: {
          text: `<p style="text-align: center;font-family: Manrope;font-size: 68px;color: rgb(0, 0, 0);line-height: 1.4;letter-spacing: 0em;"><strong><span style="color: rgb(0, 0, 0);">${text}</span></strong></p>`,
          position: { x: 271.8495002212822, y: 492.5 },
          boxSize: {
            width: 536.3009995574356,
            height: 95,
            x: 523.1390728476821,
            y: 259.9867549668875
          },
          scale: 1,
          rotate: 0,
          fonts: [
            {
              name: "Manrope",
              fonts: [
                {
                  style: "Bold",
                  urls: [
                    "https://twibbonize-assets.s3.ap-southeast-1.amazonaws.com/lido/fonts/Manrope/Manrope-Bold.woff2"
                  ]
                },
                {
                  urls: [
                    "https://twibbonize-assets.s3.ap-southeast-1.amazonaws.com/lido/fonts/Manrope/Manrope-Regular.woff2"
                  ]
                }
              ]
            }
          ],
          colors: ["rgb(0, 0, 0)"],
          fontSizes: [68]
        },
        locked: false,
        child: [],
        parent: "ROOT"
      }
    }
  };
};

export const createSubheading = (text: string) => {
  return {
    rootId: "d1b6f49a-331b-40ba-a26b-0699e711d524",
    layers: {
      "d1b6f49a-331b-40ba-a26b-0699e711d524": {
        type: { resolvedName: "TextLayer" },
        props: {
          text: `<p style="text-align: center;font-family: Manrope;font-size: 38px;color: rgb(0, 0, 0);line-height: 1.4;letter-spacing: 0em;"><strong><span style="color: rgb(0, 0, 0);">${text}</span></strong></p>`,
          position: { x: 271.8495002212822, y: 513.5 },
          boxSize: {
            width: 536.3009995574356,
            height: 53,
            x: 523.1390728476821,
            y: 259.9867549668875
          },
          scale: 1,
          rotate: 0,
          fonts: [
            {
              name: "Manrope",
              fonts: [
                {
                  style: "Bold",
                  urls: [
                    "https://twibbonize-assets.s3.ap-southeast-1.amazonaws.com/lido/fonts/Manrope/Manrope-Bold.woff2"
                  ]
                },
                {
                  urls: [
                    "https://twibbonize-assets.s3.ap-southeast-1.amazonaws.com/lido/fonts/Manrope/Manrope-Regular.woff2"
                  ]
                }
              ]
            }
          ],
          colors: ["rgb(0, 0, 0)"],
          fontSizes: [38]
        },
        locked: false,
        child: [],
        parent: "ROOT"
      }
    }
  };
};

export const createBodyText = (text: string) => {
  return {
    rootId: '3cace409-216f-4e0e-9449-9248901c8c94',
    layers: {
      '3cace409-216f-4e0e-9449-9248901c8c94': {
        type: { resolvedName: 'TextLayer' },
        props: {
          text: `<p style="text-align: center;font-family: Roboto;font-size: 26px;color: rgb(0, 0, 0);line-height: 1.4;letter-spacing: 0em;"><span style="color: rgb(0, 0, 0);">${text}</span></p>`,
          position: { x: 508.99988653474736, y: 434.903672486454 },
          boxSize: {
            width: 536.3009995574356,
            height: 36,
            x: 523.1390728476821,
            y: 259.9867549668875,
          },
          scale: 1,
          rotate: 0,
          fonts: [
            {
              name: 'Roboto',
              fonts: [
                {
                  style: 'Bold',
                  urls: [
                    'https://assets.twibbonize.com/lido/fonts/Roboto/Roboto-Bold.woff2',
                  ],
                },
                {
                  style: 'Bold_Italic',
                  urls: [
                    'https://assets.twibbonize.com/lido/fonts/Roboto/Roboto-Bold.woff2',
                  ],
                },
                {
                  style: 'Bold',
                  urls: [
                    'https://assets.twibbonize.com/lido/fonts/Roboto/Roboto-Bold.woff2',
                  ],
                },
                {
                  urls: [
                    'https://assets.twibbonize.com/lido/fonts/Roboto/Roboto-Regular.woff2',
                  ],
                },
                {
                  style: 'Italic',
                  urls: [
                    'https://assets.twibbonize.com/lido/fonts/Roboto/Roboto-Regular.woff2',
                  ],
                },
                {
                  urls: [
                    'https://assets.twibbonize.com/lido/fonts/Roboto/Roboto-Regular.woff2',
                  ],
                },
              ],
            },
          ],
          colors: ['rgb(0, 0, 0)'],
          fontSizes: [26],
        },
        locked: false,
        child: [],
        parent: 'ROOT',
      },
    },
  };
};
